import { useMsal } from "@azure/msal-react";
import { loginRequest, API_SCOPE } from "./config";
import { useCallback, useEffect } from "react";

export function useAuth() {
  const { instance, accounts } = useMsal();
  const account = accounts[0];

  useEffect(() => {
    instance.handleRedirectPromise().catch(console.error);
  }, [instance]);

  const login = useCallback(() => {
    instance.loginRedirect(loginRequest).catch(console.error);
  }, [instance]);

  const logout = useCallback(() => {
    instance.logoutRedirect({ account }).catch(console.error);
  }, [instance, account]);

  const getToken = useCallback(async () => {
    if (!account) throw new Error("Not authenticated");
    try {
      const result = await instance.acquireTokenSilent({
        scopes: [API_SCOPE],
        account,
      });
      return result.accessToken;
    } catch {
      await instance.acquireTokenRedirect({
        scopes: [API_SCOPE],
        account,
      });
      return null;
    }
  }, [instance, account]);

  return { account, isAuthenticated: !!account, login, logout, getToken };
}
